export default __webpack_public_path__ + "static/stash-205fe821c887def88c73898aa8dadd26.svg";